import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';

class FinaliseDialog extends Component {
  renderFinalisationActions = [
    <Button
      key="confirm"
      variant="contained"
      className="mr3"
      secondary="true"
      onClick={this.props.onFinalisation}
    >
      <FormattedMessage id="survey.confirmFinalisationButtonLabel" />
    </Button>,
    <Button
      key="cancel"
      variant="contained"
      className="mr3"
      primary="true"
      onClick={this.props.onCancel}
    >
      <FormattedMessage id="genericCancel" />
    </Button>,
  ];

  render() {
    return (
      <GenericDialog
        isOpen={this.props.isOpen}
        actions={this.renderFinalisationActions}
      >
        <ContentBox
          title={<FormattedMessage id="survey.finaliseDialogHeading" />}
        >
          <FormattedMessage id="survey.finalisationWarning" />
        </ContentBox>
      </GenericDialog>
    );
  }
}

FinaliseDialog.defaultProps = {
  isOpen: false,
};

FinaliseDialog.propTypes = {
  onFinalisation: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default FinaliseDialog;
